export const tablefields = [
	{
		'name': 'Project',
		'order': '1',
		'value': 'title',
		'width': 200,
		'class': 'AlignLeft',
		'sticky': true,
		'sticky_value': 0,
		'visible': true,
	},
	{
		'name': 'Date',
		'order': '2',
		'value': 'date',
		'type': 'date',
		'width': 100,
		'sticky': true,
		'sticky_value': 0,
		'version_table': '2021-12-10',
		'visible': true,
	},
	{
		'name': 'Unit',
		'order': '3',
		'value': 'unit_number',
		'width': 60,
		'sticky': true,
		'sticky_value': 100,
		'visible': true,
	},
	{
		'name': 'Category',
		'order': '4',
		'value': 'category_name',
		'type': 'back_translate',
		'class': 'AlignLeft',
		'width': 150,
		'sticky': true,
		'sticky_value': 160,
		'visible': true,
	},
	{
		'name': 'Total',
		'order': '5',
		'value': 'total_cost',
		'type': 'currency',
		'width': 100,
		'class': 'AlignRight',
		'sticky': true,
		'sticky_value': 310,
		'visible': true,
	},
	{
		'name': 'Description',
		'order': '6',
		'value': 'description',
		'class': 'AlignLeft',
		'width': 250,
		'visible': true,
	},
	{
		'name': 'Vendor',
		'order': '7',
		'value': 'vendor',
		'class': 'AlignLeft',
		'width': 250,
		'visible': true,
	},
	{
		'name': 'Status',
		'order': '8',
		'value': 'se_st_name',
		'type': 'back_translate',
		'class': 'AlignLeft',
		'width': 150,
		'visible': true,
	},
	{
		'name': 'Purchase order',
		'order': '9',
		'value': 'po',
		'class': 'AlignLeft',
		'visible': true,
	},
	{
		'name': 'Document',
		'order': '10',
		'value': 'nit',
		'class': 'AlignLeft',
		'width': 100,
		'visible': true,
	},
	{
		'name': 'On location',
		'order': '11',
		'value': 'call_time',
		'type': 'time',
		'width': 100,
		'visible': true,
	},
	{
		'name': 'Arrive',
		'order': '12',
		'value': 'arrive',
		'type': 'time',
		'width': 100,
		'visible': true,
	},
	{
		'name': 'Wrap',
		'order': '13',
		'value': 'wrap',
		'type': 'time',
		'width': 100,
		'visible': true,
	},
	{
		'name': 'Quantity',
		'order': '14',
		'value': 'quantity',
		'width': 100,
		'visible': true,
	},
	{
		'name': 'Unit cost',
		'order': '15',
		'value': 'cost_unit',
		'type': 'currency',
		'width': 100,
		'class': 'AlignRight',
		'visible': true,
	},
	{
		'name': 'Lunch',
		'order': '16',
		'value': 'lunch',
		'type': 'currency',
		'width': 100,
		'class': 'AlignRight',
		'visible': true,
	},
	{
		'name': 'H Extras',
		'order': '17',
		'value': 'extra',
		'type': 'currency',
		'class': 'AlignRight',
		'width': 100,
		'visible': true,
	},
	{
		'name': 'Periphery',
		'order': '18',
		'value': 'periphery',
		'type': 'currency',
		'class': 'AlignRight',
		'width': 100,
		'visible': true,
	},
	{
		'name': 'Invoice',
		'order': '19',
		'value': 'invoice',
		'class': 'AlignLeft',
		'width': 150,
		'visible': true,
	},
	{
		'name': 'Files',
		'order': '20',
		'value': 'files',
		'width': 80,
		'visible': true,
	},
	{
		'name': 'Observations',
		'order': '21',
		'value': 'observation',
		'width': 200,
		'class': 'AlignLeft',
		'visible': true,
	},
	{
		'name': 'Monthly',
		'order': '22',
		'value': 'monthly',
		'type': 'ok_field',
		'visible': true,
	},
	{
		'name': 'Date created',
		'order': '23',
		'value': 'created_at',
		'type': 'date',
		'width': 100,
		'visible': true,
	},
	{
		'name': 'Date approved',
		'order': '23',
		'value': 'date_approved',
		'type': 'date',
		'width': 150,
		'visible': true,
	},
	{
		'name': 'Date updated',
		'order': '24',
		'value': 'updated_at',
		'type': 'date',
		'width': 150,
		'visible': true,
	},
]